<template>
  <ny-main title="Infinities 管理员平台" platform="admin" :route-data="routeData"></ny-main>
</template>

<script>
import NyMain from '@/global/views/Main'
import { routeData } from '../router'

export default {
  name: 'Main',
  components: {
    NyMain
  },
  data () {
    return {
      routeData
    }
  }
}
</script>
